module.exports = __webpack_public_path__ + "public/images/drawing-background-pattern.cd640ff58bc6656acd8e53c629903a2d.svg";